import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';

export const MontantFrais = ({ label, montant, min, max, onValueChange, disabled }) => {

    const [value, setValue] = useState(montant);

    const handleChange = (event) => {

        let inputValue = event.target.value;

        const formattedValue = inputValue
            .replace(',', '.') // Pour le traitement, remplacer la virgule par un point
            .replace(/[^0-9.]/g, '') // Permet seulement les chiffres et le point
            .replace(/(\..*)\./g, '$1') // Empêche la saisie de plus d'un point
            .replace(/\.(\d{2})\d+/, '.$1') // Garde seulement deux chiffres après le point
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Ajoute un espace comme séparateur de milliers
            .replace('.', ','); // Affichage final avec une virgule

        setValue(formattedValue);

        let valueForBackend = formattedValue.replace(/ /g, '').replace(',', '.');

        if (/,$/.test(formattedValue)) onValueChange({ value: valueForBackend + "00" });
        else if (!/,\d+/.test(formattedValue)) onValueChange({ value: valueForBackend + ".00" });
        else onValueChange({ value: valueForBackend });

    };

    return (
        <div className="field">
            {label && <label htmlFor="montant">{label}</label>}
            <br/>
            <InputText
                id="montant"
                type="text"
                value={value}
                onChange={handleChange}
                placeholder="Montant en euros"
                title="Indiquez le montant en euros"
                aria-label="Indiquez le montant en euros"
                disabled={disabled}
                min={min}
                max={max}
            />
            <span style={{ marginLeft: '10px' }}>Euros</span>
        </div>
    );
};
